import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '@/components/Footer';
import LegalDraftNotice from '@/components/LegalDraftNotice';

export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex flex-col">
      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full" data-testid="terms-page">
        <LegalDraftNotice docName="Terms of Use document" />
        <h1 className="text-3xl font-bold mb-6">Terms of Use</h1>
        <div className="space-y-4 text-muted-foreground">
          <p>These Terms of Use govern your access to and use of Insul Nutrients. By creating an account you agree to these terms.</p>
          <p>You must be 18 years or older to use this service. Nutritional information provided is an AI-generated estimate and not medical advice.</p>
        </div>
        <Link to="/" className="inline-block mt-8 text-primary font-semibold">← Back to home</Link>
      </main>
      <Footer />
    </div>
  );
}
